import { put, call, take, fork } from 'redux-saga/effects'
import { landingPagePatchService } from 'src/api/course'
import { patchCourseLandingPageSuccess } from 'src/reducers/course/action'
import { PATCH_COURSE_LANDING_PAGE } from 'src/reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* landingPagePatchFlow(payload) {
  try {
    const { id, data, callback } = payload

    yield call(landingPagePatchService, id, data)
    yield put(patchCourseLandingPageSuccess(data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* landingPageWatcher() {
  while (true) {
    const action = yield take(PATCH_COURSE_LANDING_PAGE)
    const { payload } = action

    yield fork(generalSaga, landingPagePatchFlow, payload)
  }
}
